import request from '@/axios/bigData';
// 1获取事件类型列表
export const get_envent_enum = query => {
  return request({
    url: '/rpc/get_event_enum',
    method: 'GET',
    params: query
  });
};

// 2获取口径列表
export const get_cali_enum = query => {
  return request({
    url: '/rpc/get_cali_enum',
    method: 'GET',
    params: query
  });
};

// 3获取运算符
export const get_opt_enum = query => {
  return request({
    url: '/rpc/get_opt_enum',
    method: 'GET',
    params: query
  });
};

// 4获取事件属性列表
export const get_attr_enum_tmp = query => {
  return request({
    url: '/rpc/get_attr_enum',
    method: 'GET',
    params: query
  });
};
// 获取属性对应值列表
export const get_theme_attr_val = query => {
  return request({
    url: '/rpc/get_theme_attr_val',
    method: 'GET',
    params: query
  });
};
// 5获取某个事件属性的值列表
export const get_attr_val = query => {
  return request({
    url: '/rpc/get_attr_val',
    method: 'GET',
    params: query
  });
};

// 6获取分组列表
export const get_group_enum = query => {
  return request({
    url: '/rpc/get_group_enum',
    method: 'GET',
    params: query
  });
};

// 7获取时间周期列表
export const get_period_enum = query => {
  return request({
    url: '/rpc/get_period_enum',
    method: 'GET',
    params: query
  });
};



// 查询接口
export const rpcQueryApi = (query) => {
  return request({
    url: '/rpc/query',
    method: 'post',
    data: query
  })
}

// 按名保存配置
export const save_config = (query) => {
  return request({
    url: '/rpc/config_save',
    method: 'post',
    data: query
  })
}

// 获取保存看板列表
export const config_saved_list = query => {
  return request({
    url: '/rpc/config_saved_list',
    method: 'GET',
    params: query
  });
};

// 获取某个看板的配置
export const config_query = query => {
  return request({
    url: '/rpc/config_query',
    method: 'GET',
    params: query
  });
};

// 检查某个看板名称是否存在
export const config_check = query => {
  return request({
    url: '/rpc/config_check',
    method: 'post',
    data: query
  });
};


// 删除某个看板
export const config_delete = query => {
  return request({
    url: '/rpc/config_delete',
    method: 'GET',
    params: query
  });
};


// 导出excel 
export const export_excel = query => {
  return request({
    url: '/rpc/export_excel',
    method: 'post',
    data: query
  });
};

// abi图表
export const getAbiMenu = () => {
  return request({
    url: '/rpc/get_abi_menu',
    method: 'GET'
  });
};


//申明式生成SQL
export const get_sql_from_yaml = query => {
  return request({
    url: '/rpc/get_sql_from_yaml',
    method: 'post',
    data: query
  });
};

//Dataworks 任务
export const add_datawork = query => {
  return request({
    url: '/rpc/add_datawork',
    method: 'post',
    data: query
  });
};

//  获取任务的tags
export const t_abi_get_tags = query => {
  return request({
    url: '/rpc/t_abi_get_tags',
    method: 'post',
    data: query
  });
};

//  获取任务的状态
export const t_abi_get_task_status = query => {
  return request({
    url: '/rpc/t_abi_get_task_status',
    method: 'post',
    data: query
  });
};


//  启动任务
export const t_abi_run = query => {
  return request({
    url: '/rpc/t_abi_run',
    method: 'post',
    data: query
  });
};

//  获取日志
export const t_abi_get_log = query => {
  return request({
    url: '/rpc/t_abi_get_log',
    method: 'post',
    data: query
  });
};

// 获取数据集类型
export const t_abi_get_theme = () => {
  return request({
    url: '/rpc/t_abi_get_theme',
    method: 'GET'
  });
};

//  可视化sql-查统计信息（直接查sql）
export const db_query = query => {
  return request({
    url: '/rpc/db_query',
    method: 'post',
    data: query
  });
};



//  可视化sql-查明细-下拉主题
export const get_detail_query_theme = query => {
  return request({
    url: '/rpc/get_detail_query_theme',
    method: 'GET',
    params: query,
  });
};


//  可视化sql-查明细 
export const db_query_detail = query => {
  return request({
    url: '/rpc/db_query_detail',
    method: 'post',
    data: query
  });
};

//  用户查询记录
export const get_db_query_his = query => {
  return request({
    url: '/rpc/get_db_query_his',
    method: 'GET',
    params: query,
  });
};



//以下是用户分群接口

//  获取事件列表
export const up_get_event_enum = query => {
  return request({
    url: '/rpc/up_get_event_enum',
    method: 'GET',
    params: query,
  });
};
//  获取事件口径/运算符的对照字典
export const up_get_cali_enum = query => {
  return request({
    url: '/rpc/up_get_cali_enum',
    method: 'GET',
    params: query,
  });
};
//  获取事件属性对照字典
export const up_get_event_attrs = query => {
  return request({
    url: '/rpc/up_get_event_attrs',
    method: 'GET',
    params: query,
  });
};
//  获取事件属性运算符
export const up_get_event_attr_opt = query => {
  return request({
    url: '/rpc/up_get_event_attr_opt',
    method: 'GET',
    params: query,
  });
};

//  获取事件属性的值
export const up_get_event_attr_val = query => {
  return request({
    url: '/rpc/up_get_event_attr_val',
    method: 'GET',
    params: query,
  });
};

//  获取事件-口径下拉候选值
export const up_get_event_cali_val = query => {
  return request({
    url: '/rpc/up_get_event_cali_val',
    method: 'GET',
    params: query,
  });
};

//  保存配置
export const up_config_save = query => {
  return request({
    url: '/rpc/up_config_save ',
    method: 'post',
    data: query
  });
};


//  查询分群列表
export const up_config_saved_list = query => {
  return request({
    url: '/rpc/up_config_saved_list',
    method: 'GET',
    params: query,
  });
};

// 删除某个分群
export const up_config_delete = query => {
  return request({
    url: '/rpc/up_config_delete',
    method: 'GET',
    params: query,
  });
};


//  查询单个分群
export const up_config_query = query => {
  return request({
    url: '/rpc/up_config_query',
    method: 'GET',
    params: query,
  });
};

//  手动刷新
export const up_job_submit = query => {
  return request({
    url: '/rpc/up_job_submit',
    method: 'GET',
    params: query,
  });
};

// 以下是质量监控接口

//  公共属性筛选
export const qual_get_public_attr = query => {
  return request({
    url: '/rpc/qual_get_public_attr',
    method: 'GET',
    params: query,
  });
};

//  通用属性筛选
export const qual_get_general_attr = query => {
  return request({
    url: '/rpc/qual_get_general_attr',
    method: 'GET',
    params: query,
  });
};

//  校验口径
export const qual_get_valid = query => {
  return request({
    url: '/rpc/qual_get_valid',
    method: 'GET',
    params: query,
  });
};

//  运算符
export const qual_get_opt = query => {
  return request({
    url: '/rpc/qual_get_opt',
    method: 'GET',
    params: query,
  });
};

//  保存配置
export const qual_config_save = query => {
  return request({
    url: '/rpc/qual_config_save ',
    method: 'post',
    data: query
  });
};

//  根据id查询单个配置
export const qual_config_query = query => {
  return request({
    url: '/rpc/qual_config_query',
    method: 'GET',
    params: query,
  });
};

//  查询配置列表
export const qual_config_saved_list = query => {
  return request({
    url: '/rpc/qual_config_saved_list',
    method: 'post',
    data: query,
  });
};

//  删除配置
export const qual_config_delete = query => {
  return request({
    url: '/rpc/qual_config_delete',
    method: 'GET',
    params: query,
  });
};

//  查询错误数据
export const qual_query_error_data = query => {
  return request({
    url: '/rpc/qual_query_error_data',
    method: 'post',
    data: query,
  });
};

//  查询已处理的错误数据
export const qual_query_error_data_del = query => {
  return request({
    url: '/rpc/qual_query_error_data_del',
    method: 'post',
    data: query,
  });
};

//  清除数据
export const qual_rule_data_delete = query => {
  return request({
    url: '/rpc/qual_rule_data_delete',
    method: 'post',
    data: query,
  });
};

//  下载数据
export const qual_rule_data_export_excel = query => {
  return request({
    url: '/rpc/qual_rule_data_export_excel',
    method: 'post',
    data: query,
  });
};

//  总量数据统计
export const qual_query_error_data_statistics = query => {
  return request({
    url: '/rpc/qual_query_error_data_statistics',
    method: 'post',
    data: query,
  });
};

//  手动更新接口
export const event_quality = query => {
  return request({
    url: '/rpc/event_quality',
    method: 'GET',
    params: query,
  });
};

// 保存用户图谱配置
export const graph_config_save = query => {
  return request({
    url: '/rpc/graph_config_save',
    method: 'post',
    data: query,
  });
}

// 查询用户图谱列表
export const graph_config_saved_list = params => {
  return request({
    url: '/rpc/graph_config_saved_list',
    method: 'get',
    params: params,
  });
};

// 查询用户图谱分析配置
export const graph_config_query = params => {
  return request({
    url: '/rpc/graph_config_query',
    method: 'get',
    params: params,
  });
};

// 查询用户图谱数据
export const graph_query_by_id = params => {
  return request({
    url: '/rpc/graph_query_by_id',
    method: 'get',
    params: params,
  });
};

// 删除用户图谱数据
export const graph_config_delete = params => {
  return request({
    url: '/rpc/graph_config_delete',
    method: 'get',
    params: params,
  });
};

// 刷新用户图谱数据
export const graph_job_submit = params => {
  return request({
    url: '/rpc/graph_job_submit',
    method: 'get',
    params: params,
  });
};

// 刷新用户图谱数据
export const graph_get_path_list = () => {
  return request({
    url: '/rpc/graph_get_path_list',
    method: 'get'
  });
};


// 虚拟事件-获取虚拟事件列表
export const virtual_event_list = query => {
  return request({
    url: '/rpc/virtual_event_list',
    method: 'GET',
    params: query
  });
};

// 虚拟事件-删除虚拟事件
export const virtual_event_delete = query => {
  return request({
    url: '/rpc/virtual_event_delete',
    method: 'GET',
    params: query
  });
};


// 虚拟事件-获取事件列表
export const get_vir_event_enum = query => {
  return request({
    url: '/rpc/get_vir_event_enum',
    method: 'GET',
    params: query
  });
};

// 虚拟事件-获取属性列表
export const get_vir_attr_enum = query => {
  return request({
    url: '/rpc/get_vir_attr_enum',
    method: 'GET',
    params: query
  });
};

// 虚拟事件-保存虚拟事件详单（新增）
export const virtual_event_save = query => {
  return request({
    url: '/rpc/virtual_event_save',
    method: 'post',
    data: query,
  });
}

// 虚拟事件-虚拟事件引用校验（新增）
export const virtual_event_quote_check = query => {
  return request({
    url: '/rpc/virtual_event_quote_check',
    method: 'GET',
    params: query
  });
};

// 虚拟事件-获取虚拟事件详单（新增）
export const get_virtual_event_detail = query => {
  return request({
    url: '/rpc/get_virtual_event_detail',
    method: 'GET',
    params: query
  });
};

//  离线ABI权限控制）--------------------------------

// 离线ABI-获取菜单目录
export const get_abi_menu_tmp = query => {
  return request({
    url: '/rpc/get_abi_menu',
    method: 'GET',
    params: query
  });
};

// 离线ABI-授权菜单给用户
export const abi_authorize_user = query => {
  return request({
    url: '/rpc/abi_authorize_user',
    method: 'post',
    data: query,
  });
}

// 离线ABI-授权菜单给角色
export const abi_authorize_role = query => {
  return request({
    url: '/rpc/abi_authorize_role',
    method: 'post',
    data: query,
  });
}

// 离线ABI-获取用户列表
export const get_user_list = query => {
  return request({
    url: '/rpc/get_user_list',
    method: 'GET',
    params: query
  });
};

// 离线ABI-获取角色列表
export const get_role_list = query => {
  return request({
    url: '/rpc/get_role_list',
    method: 'GET',
    params: query
  });
};

// 离线ABI-撤回菜单给用户
export const abi_revoke_authorize_user = query => {
  return request({
    url: '/rpc/abi_revoke_authorize_user',
    method: 'post',
    data: query,
  });
}

// 离线ABI-撤回授权菜单角色
export const abi_revoke_authorize_role = query => {
  return request({
    url: '/rpc/abi_revoke_authorize_role',
    method: 'post',
    data: query,
  });
}

// 离线ABI-判断用户超管
export const is_user_super = query => {
  return request({
    url: '/rpc/is_user_super',
    method: 'GET',
    params: query
  });
};
